import {Card, Statistic} from "antd";
import React from "react";
import {useQuery} from "react-query";
import {AdminApi} from "src/apis/admin.api";

const ApprovedUsersCardComponent: React.FC = () => {
  const query = useQuery(
    "totalApprovedUsers",
    () => AdminApi.statsTotalStatistics("approvedUsers"),
    {refetchInterval: 60 * 1000}
  )

  return (
    <Card>
      <Statistic
        title="Usuarios aprobados"
        value={query.data?.total}
        loading={!query.data}
      />
    </Card>
  )
}

export default ApprovedUsersCardComponent